<template>
  <LoadingWrapper :state="organizationLoadingStatus">
    <EditOrganizationMembers :organization="organizationData" />
  </LoadingWrapper>
</template>
<script setup lang="ts">
  import LoadingWrapper from '../../../core/components/loading/LoadingWrapper.vue'
  import { useOrganization } from '../composables/useOrganization'
  import EditOrganizationMembers from '../components/EditOrganizationMembers.vue'

  const { data: organizationData, status: organizationLoadingStatus } = useOrganization()
</script>
